import { Customer } from '@/model/Customer';
import { CRUD } from './base/crud';

class CustomersAppService extends CRUD<Customer, any> {
    readonly endPoint = 'admin/customers-app';
}

export const customersAppService = new CustomersAppService();
